(function () {
  window.addEventListener('load', (event) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://sdk.onfido.com/v14.24.0';
    document.body.appendChild(script);
  });
})();
